export async function open(target) {
  window.open(target, "_blank", "noopener,noreferrer");
}
